import RequestUtils from "utils/RequestUtils";
import CastNotificationRes from "types/res/notification/CastNotificationRes";

export default class NotificationApi {
  static async fetchNotifications(companyId: number) {
    return await RequestUtils.get(
      CastNotificationRes,
      `/notification/findAll/${companyId}`
    );
  }
  static async readNotifications(companyId: number, req: number[]) {
    return await RequestUtils.postVoid(
      `/notification/isRead/${companyId}`,
      req
    );
  }
}
